var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplash = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "OBJECTS",
    x: 0,
    y: 0,
    viewBox: "0 0 455.9 379.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}.st4{fill:#5f2e28}.st5{fill:#bd6d70}.st6{fill:#ff818c}.st7{fill:#cc545c}.st12{stroke-width:4}.st12,.st13{fill:none;stroke:#5f2e28;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m168.9 278-12.1 61.2c-1.1 5.8 3.5 11.1 9.7 11.1h107.8v-8.2h-28.9c-4.8 0-8.5-3.9-7.9-8.4L244 278z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m177.9 278-12.1 61.2c-1.1 5.8 3.5 11.1 9.7 11.1h107.8v-8.2h-28.9c-4.8 0-8.5-3.9-7.9-8.4L253 278z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.8 342.1h92.4v8.2h-92.4z",
    style: {
      fill: "#fcf1f2"
    },
    transform: "rotate(-180 237.057 346.192)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.7 342.1c.6 4.6 4.7 8.2 9.8 8.2h24.3v-8.2h-22.5c-1.6 0-2.9-1.3-2.6-2.8l12.1-61.3h-9l-12.1 61.3c-.1.9-.1 1.9 0 2.8",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.7 285.6H63.4c-11.3 0-20.4-9.1-20.4-20.4V56.1c0-11.3 9.1-20.4 20.4-20.4h291.3c11.3 0 20.4 9.1 20.4 20.4v209.1c0 11.3-9.1 20.4-20.4 20.4",
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389.9 57.4V264c0 12-9.7 21.7-21.7 21.7H79.5c-12 0-21.7-9.7-21.7-21.7V57.4c0-12 9.7-21.7 21.7-21.7h288.7c12 .1 21.7 9.8 21.7 21.7",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.9 57.4v184.9h-332V57.4c0-12 9.7-21.7 21.7-21.7h288.7c11.9.1 21.6 9.8 21.6 21.7",
    style: {
      fill: "#fafafa"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328 157.7h-57.3c-3 0-5.5-2.5-5.5-5.5V94.9c0-3 2.5-5.5 5.5-5.5H328c3 0 5.5 2.5 5.5 5.5v57.3c0 3-2.5 5.5-5.5 5.5M293.9 83.4H135.6c-8.8 0-15.9-7.1-15.9-15.9s7.1-15.9 15.9-15.9h158.2c8.8 0 15.9 7.1 15.9 15.9.1 8.8-7 15.9-15.8 15.9",
    className: "st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 293,
    cy: 67.5,
    r: 11.3,
    className: "st4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m299.3 72.6-3.2-3.2c.7-.9 1.1-2 1.1-3.3 0-3-2.4-5.4-5.4-5.4s-5.4 2.4-5.4 5.4 2.4 5.4 5.4 5.4c1 0 1.9-.3 2.8-.8l3.3 3.3c.4.4 1.1.4 1.5 0 .3-.4.3-1-.1-1.4m-7.5-2.9c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6 3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6",
    className: "st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.4 63.5h129.9v1.8H139.4zM139.4 69.7h94.7v1.8h-94.7z",
    className: "st5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.3 145.9h-39.9l.1-1.7.1-1.2.1-1.4.1-1.2.1-1.4.1-1.2.1-1.4.1-1.2 2.5-33.9h6.6c0 5.6 4.5 10.1 10.1 10.1s10.1-4.5 10.1-10.1h6.6l2.5 33.9.1 1.2.1 1.4.1 1.2.1 1.4.1 1.2.1 1.4.1 1.2z",
    className: "st6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m282.6 101.2-12.2 15.1 10.5 8.8zM316.1 101.2l12.2 15.1-10.5 8.8zM318.6 136.3h-38.5l.1-1.2h38.3zM318.8 138.9h-38.9l.1-1.2h38.7zM319 141.6h-39.3l.1-1.2h39.1zM319.2 144.3h-39.7l.1-1.2h39.5z",
    className: "st7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m447.4 203.5-59.7-52.7q-.9-.75-2.1-.6l-23.6 4.5-.6.1-9.1 1.7c-1.1.2-1.9 1.1-2 2.2l-.6 9v.8l-1.5 24c-.1.7.3 1.5.8 2l59.6 52.7c1 .9 2.5.8 3.4-.2l35.4-40.1c1.1-1 1-2.5 0-3.4m-84.3-35.6c-1.2 1.3-3.2 1.4-4.5.3h-.1l-.2-.2c-.2-.2-.3-.4-.4-.6-.7-1.2-.6-2.7.4-3.7 1-1.1 2.5-1.4 3.7-.8.3.1.5.3.7.5l.1.1c1.4 1.1 1.5 3.1.3 4.4",
    className: "st6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M442.4 203.4 387.5 155c-.6-.5-1.3-.7-2-.6l-22.4 3.7-.7.1-6.8 1.1c-1.1.2-1.9 1.1-1.9 2.2l-1.2 30.3c0 .7.3 1.4.8 1.9l54.9 48.5c1 .9 2.5.8 3.4-.1l31.1-35.2c.8-1.1.7-2.6-.3-3.5m-.1 3.1-31.1 35.2c-.7.8-1.9.8-2.8.1l-54.9-48.5c-.5-.4-.7-1-.7-1.6l1.2-30.3c0-.4.2-.8.5-1.2.3-.3.7-.5 1.1-.6l6.7-1.1.7-.1 22.4-3.7c.6-.1 1.2.1 1.7.5l54.9 48.5c.9.8 1 2 .3 2.8",
    className: "st0"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    style: {
      fontFamily: "&quot",
      fontSize: "34.3162px"
    },
    transform: "rotate(41.444 -64.2 567.353)"
  }, "SALE"), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331.2 162.7c-2-1.4-3.8-3.1-5.2-5h-4.6c1.9 3.3 4.7 6.3 7.6 8.3 6.1 4.1 12.8 5.5 18.5 5.5.7 0 1.4 0 2.1-.1l.2-3.9c-5.6.4-12.7-.8-18.6-4.8m25.8-10.5c-3.2-4-7.4-6.3-11.8-7.6-6.3-1.8-19.1-.4-23.3 2.2.2 1.7 1.4 3.1 3.1 2.7 6.3-2 19-5.8 29 5.1 3.7 4.1 6.1 10.2 3.6 10.7-.1.7 0 1.5.7 2.4.4.5.9.8 1.3 1 .4-.3.8-.5 1.1-.8q1.2-1.05 1.5-2.4c.7-3.2-1.2-8.3-5.2-13.3",
    className: "st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 209.5H27.6l15.3 140.8h102.7z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 209.5 15.3 140.8H7.4z",
    style: {
      fill: "#e56a74"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.1 218.8s-2.5-11.8-5.2-23.9c-4.9-21.6-39.7-21.1-37.3 2.9 1.4 14.3 2.5 21 2.5 21",
    className: "st12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1 349.2 23 338.8 8.9 349.2M24.5 295.7l2.2-64.7M24 309.9l.2-6.1M23 338.8l.6-16.8M43.1 202.8H21.2L8.3 292.9",
    className: "st13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.3 243.3H75.9l11.6 107h102.1z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m75.9 243.3 11.6 107h-27z",
    style: {
      fill: "#c25347"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 250.3s-2.3-9-4.7-18.1c-4.4-16.4-36.1-16.1-33.9 2.2 1.3 10.8 2.3 15.9 2.3 15.9",
    className: "st12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m86.1 349.5-13.7-7.9-10.7 7.9M73.5 308.8l1.7-49.2M73.1 319.6l.2-4.6M72.4 341.6l.4-12.8M159.9 238.4h18.3l5.9 40.9",
    className: "st13"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m371 289.3-75.8 40.4c-2.5 1.3-5.6.4-7-2.1L263 280.2c-1.3-2.5-.4-5.6 2.1-7l75.8-40.4c2.5-1.3 5.6-.4 7 2.1l25.2 47.4c1.4 2.6.4 5.7-2.1 7",
    className: "st5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m366.9 276.9 2.3 4.4c1.3 2.5.4 5.5-2.1 6.9M265.3 290.8l-6.3-11.9c-1.3-2.5-.4-5.5 2.1-6.9l76-40.5c2.5-1.3 5.5-.4 6.9 2.1l10.9 20.6M280.1 318.6l-4-7.6-7-13.1M309.9 318.6l-18.8 10c-2.5 1.3-5.5.4-6.9-2.1",
    className: "st13"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m276.64 305.763 84.906-45.233 7.665 14.387-84.907 45.233z",
    className: "st4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m276.508 288.142 15.534-8.276 4.043 7.59-15.533 8.276z",
    className: "st0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m295.956 277.823 28.949-15.423.752 1.412-28.949 15.423zM298.025 281.586l16.593-8.84.752 1.413-16.593 8.84z",
    className: "st4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.1 46.5H81.4L56.1 14.8h29.7z",
    className: "st0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7 46.5H111L85.7 14.8h29.7z",
    className: "st6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M200.1 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M229.7 46.5h-29.6l-25.4-31.7h29.7z",
    className: "st0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M259.4 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M289.1 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M348.4 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M378.1 46.5h-29.7l-25.3-31.7h29.7z",
    className: "st6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M407.8 46.5h-29.7l-25.3-31.7h21.4c5.2 0 10 2.1 12.7 5.5z",
    className: "st0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1 14.8s-14.5 3-14.5 15.2v16.5h39.8z",
    className: "st6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M111.1 46.5c-.1.7-2.1 9.6-14.9 9.6-10.6 0-14.8-9.6-14.8-9.6z",
    className: "st0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7 46.5c-.1.6-2 9.6-14.8 9.6-10.2 0-14.5-8.9-14.8-9.6z",
    className: "st6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 46.5c-.1.7-2.1 9.6-14.9 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.1 46.5c-.1.6-2 9.6-14.8 9.6-10.2 0-14.5-8.9-14.8-9.6z",
    className: "st6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M229.7 46.5c-.1.6-2 9.6-14.9 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M259.4 46.5c-.1.6-2 9.6-14.8 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M289.1 46.5c-.1.6-2 9.6-14.9 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 46.5c-.1.6-2 9.6-14.8 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M348.4 46.5c-.1.6-2 9.6-14.8 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M378.1 46.5c-.1.6-2 9.6-14.8 9.6-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M407.8 46.5s-1.6 9.6-14.8 9.6c-10.3 0-14.6-9.1-14.8-9.6z",
    className: "st0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/splash.662793c1.svg";